import { useContext } from 'react';
import { PatientRow } from './PatientRow';
import { TableContext } from '../index';
import { Table, TableBody } from '@mui/material';

export const PatientsList = () => {
  const { patients, handleDeletePatient } = useContext(TableContext);

  return (
    <TableBody style={{ padding: '0 25px' }}>
      {patients.map((patient, index) => {
        return (
          <PatientRow
            handleDeletePatient={handleDeletePatient}
            id={index + 1}
            key={index}
            patient={patient}
          />
        );
      })}
    </TableBody>
  );
};
